import React from "react";
import { getSectionStatusMeta } from "../utils/bookingFlowRules";

const SectionStatusHeader = ({
  title,
  state,
  isMobile,
  sectionExpanded,
  onToggle,
  actionLabel,
  actionDisabled = false,
  hideTopControls = false,
  hideGuidance = false,
}) => {
  const status = getSectionStatusMeta(state);
  const resolvedActionLabel = actionLabel || (sectionExpanded ? "Next" : "Open");

  return (
    <div style={{ marginBottom: "12px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          marginBottom: "6px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: "600",
            color: "#1a1a1a",
          }}
        >
          {title}
        </h3>
        {!hideTopControls && (
          <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
            <span
              style={{
                fontSize: isMobile ? "10px" : "11px",
                fontWeight: "700",
                letterSpacing: "0.3px",
                textTransform: "uppercase",
                padding: "4px 8px",
                borderRadius: "999px",
                background: status.background,
                color: status.color,
                border: `1px solid ${status.border}`,
                lineHeight: 1.1,
              }}
            >
              {status.label}
            </span>
            {onToggle ? (
              <button
                type="button"
                onClick={onToggle}
                disabled={actionDisabled}
                style={{
                  padding: "4px 8px",
                  borderRadius: "999px",
                  border: "1px solid #d1d5db",
                  background: "#fff",
                  color: "#374151",
                  fontSize: "11px",
                  fontWeight: "600",
                  cursor: actionDisabled ? "not-allowed" : "pointer",
                  opacity: actionDisabled ? 0.6 : 1,
                }}
                aria-expanded={sectionExpanded}
              >
                {resolvedActionLabel}
              </button>
            ) : null}
          </span>
        )}
      </div>
      {status.guidance && !hideGuidance ? (
        <div
          style={{
            fontSize: "12px",
            color: status.color,
            opacity: 0.9,
          }}
        >
          {status.guidance}
        </div>
      ) : null}
    </div>
  );
};

export default SectionStatusHeader;
